export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["DRAFT"] = "DRAFT";
    QuoteStatus["DELETED"] = "DELETED";
    QuoteStatus["SENT"] = "SENT";
    QuoteStatus["DECLINED"] = "DECLINED";
    QuoteStatus["ACCEPTED"] = "ACCEPTED";
    QuoteStatus["CONVERTED"] = "CONVERTED";
    QuoteStatus["UNKNOWN"] = "UNKNOWN";
})(QuoteStatus || (QuoteStatus = {}));
/** Quotes allowed to be viewed in portal */
export const viewableQuoteStatuses = [
    QuoteStatus.SENT,
    QuoteStatus.DECLINED,
    QuoteStatus.ACCEPTED,
    QuoteStatus.CONVERTED,
];
//# sourceMappingURL=quote.js.map